import { type SimpleSite, useApiTradeV1TradeCompaniesTradeSitesRetrieve } from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<SimpleSite>, 'options'> & {
  tradeCompanyId?: number;
};

/**
 * @deprecated use TradeCompanySiteAutocomplete instead
 */
export const TradeCompanySiteSelector = ({ tradeCompanyId, required = false, ...rest }: Props) => {
  const { data, isLoading } = useApiTradeV1TradeCompaniesTradeSitesRetrieve(tradeCompanyId || 0, {
    query: {
      enabled: Boolean(tradeCompanyId),
    },
  });

  return (
    <AutocompleteField<SimpleSite>
      options={data?.results || []}
      loading={isLoading}
      data-testid="trade-site-selector"
      disabled={Boolean(!tradeCompanyId)}
      getOptionLabel={(item) => {
        if (!item.full_address) {
          return '';
        }
        return item.full_address;
      }}
      valueField="id"
      required={required}
      {...rest}
    />
  );
};
